/**
 * MandateMobileHeader — compact back + title for mandate deep routes.
 */
import { ChevronLeft } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { resolveMandateTitle } from './mandateNavConfig';

interface MandateMobileHeaderProps {
  visible?: boolean;
}

export function MandateMobileHeader({ visible = true }: MandateMobileHeaderProps) {
  const location = useLocation();
  const navigate = useNavigate();

  if (!visible) return null;

  const title = resolveMandateTitle(location.pathname);

  return (
    <header className="pa-pt-safe fixed top-0 inset-x-0 z-40 bg-white/90 dark:bg-[color-mix(in_srgb,var(--bg-raised)_90%,transparent)] backdrop-blur-md border-b border-gray-200 dark:border-[var(--rule)]">
      <div className="h-11 px-2 flex items-center gap-1">
        <button
          type="button"
          onClick={() => navigate(-1)}
          aria-label="Back"
          className="h-9 w-9 inline-flex items-center justify-center rounded-full text-gray-600 dark:text-[var(--text-sec)] active:bg-gray-100 dark:active:bg-[var(--hover-tint)]"
        >
          <ChevronLeft className="h-5 w-5" />
        </button>
        <h1 className="flex-1 text-center font-fieldwork text-sm font-semibold text-gray-900 dark:text-[var(--text-pri)] truncate px-1">
          {title}
        </h1>
        <div className="w-9 flex-shrink-0" aria-hidden />
      </div>
    </header>
  );
}
